module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA6.721890dd.jpg";